import styled from 'styled-components';

export const FlexContainer = styled.div`
  display: flex;
  flex-flow: column wrap;

  margin: 10px 10px;
  margin-top: 20px;
`;

export const AllTasks = styled.div`
  margin-top: 20px;
`;

export const Box = styled.div`
  padding: 5px;
  margin-bottom: 10px;
  background-color: rgba(156, 156, 156, 0.651);
  box-shadow: 0px 0px 5px 5px rgba(56, 56, 56, 0.2);
`;
